import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffConfiguration = () => import('./staff/configuration')
const ViewStaffQuery = () => import('./staff/query')
const ViewStaffLog = () =>  import('./staff/log')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'BCRAStaffDashboard',
  configuration: 'BCRAStaffConfiguration',
  query: 'BCRAStaffQuery',
  logs: 'BCRAStaffLog',
}

const router =
  [
    {
      path: '/st/bcra',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Situacion BCRA',
          }                                  
        },
        {
          path: 'configuration',
          name: VIEWS.configuration,
          component: ViewStaffConfiguration,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'BCRA configuración',
          }                                  
        }, 
        {
          path: 'query',
          name: VIEWS.query,
          component: ViewStaffQuery,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'BCRA consulta',
          }                                  
        },  
        {
          path: 'query/:params',
          name: 'BCRAStaffQueryParams',
          component: ViewStaffQuery,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'BCRA consulta',
          }                                  
        },                           
        {
          path: 'log',
          name: VIEWS.logs,
          component: ViewStaffLog,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'BCRA log',
          }                                  
        },                          
      ]
    },

    {
      path: '/cu/bcra',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/bcra',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
